import type { InvoiceChannel } from "@/lib/api/types";

/**
 * Whether tapping close should interrupt with the covers prompt rather than
 * closing straight away (covers rework, Phase 1 — B117 round table 2 Q6).
 *
 * Gated on DINE_IN: a takeaway bag and a delivery order carry no table and no
 * cover count at all — `guestCount` is never asked on those channels — so
 * interrupting a takeaway close with "how many people were at the table?"
 * would ask a question the bill structurally cannot answer. The other two
 * conditions are the pre-existing rule this function extracts unchanged: ask
 * only while the count is genuinely blank, and only once per bill.
 */
export function shouldPromptForCovers(input: {
  channel: InvoiceChannel;
  guestCount: number | null;
  coversAsked: boolean;
}): boolean {
  return (
    input.channel === "DINE_IN" &&
    input.guestCount === null &&
    !input.coversAsked
  );
}
